import { render } from "./EventRegistration.vue?vue&type=template&id=e8901064&scoped=true"
import script from "./EventRegistration.vue?vue&type=script&lang=js"
export * from "./EventRegistration.vue?vue&type=script&lang=js"

import "./EventRegistration.vue?vue&type=style&index=0&id=e8901064&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8901064"]])

export default __exports__